export default __webpack_public_path__ + "static/media/anotations.8cc1ec00.svg";